// src/firebase/solo.js
import {
  doc, collection, setDoc, onSnapshot, serverTimestamp, getDoc, query, where, limit, orderBy
} from 'firebase/firestore';
import { db } from './index';

const LEGACY_LS_PREFIX = 'solo_best_';

// Earlier versions cached personal bests in localStorage; Firestore is now the only source.
(function purgeLegacyLocalBests() {
  try {
    Object.keys(localStorage)
      .filter(key => key.startsWith(LEGACY_LS_PREFIX))
      .forEach(key => localStorage.removeItem(key));
  } catch { /* storage unavailable */ }
})();

/**
 * Save a solo game score to Firestore if it beats the stored best.
 */
export const saveSoloScore = async (uid, playerName, gameId, score) => {
  if (!uid || !gameId || score == null) return;
  try {
    const docRef = doc(db, 'soloScores', `${uid}_${gameId}`);
    const snap = await getDoc(docRef);
    if (!snap.exists() || score > (snap.data().score || 0)) {
      await setDoc(docRef, {
        uid,
        name: playerName || 'Player',
        gameId,
        score,
        updatedAt: serverTimestamp(),
      });
    }
  } catch (e) {
    console.warn('saveSoloScore Firestore failed:', e);
  }
};

/**
 * Get the player's saved personal best for a game from Firestore (0 if none).
 */
export const getSoloBest = async (uid, gameId) => {
  if (!uid || !gameId) return 0;
  try {
    const snap = await getDoc(doc(db, 'soloScores', `${uid}_${gameId}`));
    return snap.exists() ? snap.data().score || 0 : 0;
  } catch (e) {
    console.warn('getSoloBest failed:', e);
    return 0;
  }
};

/**
 * Listen to the best scores for a game (up to limitCount players). Returns an unsubscribe fn.
 */
export const listenSoloLeaderboard = (gameId, callback, limitCount = 200) => {
  const q = query(
    collection(db, 'soloScores'),
    where('gameId', '==', gameId),
    orderBy('score', 'desc'),
    limit(limitCount)
  );
  return onSnapshot(q, (snap) => {
    const entries = snap.docs.map(d => d.data());
    callback(entries);
  }, (err) => {
    console.warn('listenSoloLeaderboard error:', err);
    callback([]);
  });
};
